// extracted by mini-css-extract-plugin
export var gradient = "fn_l1";